<lib-prod-grid [title]="prodGridTitle"
               [columns]="prodGridColumns"
               [isAddButtonShown]="false"
               [isEditButtonShown]="false"
               [isRemoveButtonShown]="false"
               [matTableDataSource]="matTableDataSource"
               [inputAction$]="inputAction$"
               (outputAction$)="outputActionEvents($event)">
</lib-prod-grid>
